import { enums } from './value/enums'
import { translates } from './value/translates'
export function ecbRun($rootScope) {
    "ngInject"

    $rootScope.enums = enums;
    $rootScope.translate = translates;


    // add target _self to all none angular <a> tag
    $(document).ready(() => {
        let all_a_tags = $('a').each(function (a) {
            if ($(this).attr('ng-href') || $(this).attr('target')) {

            }
            else {
                $(this).attr('target', '_self')
            }
        });
    })
}


// WEBPACK FOOTER //
// ./src/store-modules/app/ecb.run.ts